export default {
  triggers: []
};